var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_369_2125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3499 19.35V0.650059H0.65V19.35H19.3499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_369_2125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 17C15.8028 14.2246 13.098 12.3571 10 12.3571C6.90196 12.3571 4.19726 14.2246 2.75 17",
    stroke: "#807A98",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3504 8.17836C14.3504 5.87058 12.4028 3.99979 10.0004 3.99979C7.59793 3.99979 5.65039 5.87058 5.65039 8.17836C5.65039 10.4861 7.59793 12.3569 10.0004 12.3569C12.4028 12.3569 14.3504 10.4861 14.3504 8.17836Z",
    stroke: "#807A98",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cfa2727f3d58ba785c8998b6f92e233d.svg";
export { ForwardRef as ReactComponent };